import { action } from 'satcheljs';
import { SelectedCalendarListViewType } from 'owa-scenario-settings';

export const updateSelectedCalendarViewInStore = action(
    'updateSelectedCalendarViewInStore',
    (updatedView: SelectedCalendarListViewType) => ({
        updatedView,
    })
);
